export default "__VITE_PUBLIC_ASSET__744960d2__"